import { default as PhoneInput } from "@punchup/ui-common/components/common/phone-input";

export default PhoneInput;
